import { styled } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";
import { Link } from "react-router-dom";
import admin_login from "../../../../assets/images/admin_login.png";

const AdminLoginMain = styled("div")(({ theme }) => ({
  // backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${admin_login})`,
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundBlendMode: "overlay",
  width: "100%",
  height: "100vh",
  display: "flex",
  alignItems: "center",
}));
const LoginBox = styled("div")(({ theme }) => ({
  background: "#F4F4F4",
  border: "0.589px solid #878787",
  boxShadow: "0px 4.712px 75.392px rgba(0, 0, 0, 0.05)",
  width: "100%",
  maxWidth: "450px",
  marginLeft: "10rem",
  padding: "25px 20px",
}));
const HeaderLogo = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& h6": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "30px",
    lineHeight: "41px",
    color: "#0B0B0B",
  },
  "& img": {
    width: "100px",
  },
}));
const SignIntext = styled("div")(({ theme }) => ({
  marginTop: "20px",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "34px",
    lineHeight: "46px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
  },
}));
const FormMain = styled("div")(({ theme }) => ({
  marginTop: "20px",

  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& input": {
    background: "#FFFFFF",
    border: "0.7068px solid #0B0B0B",
    borderRadius: "10px",
  },
}));
const ForgotPasswordMain = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));
const ForgotPasswordLink = styled(Link)(({ theme }) => ({
  fontFamily: "'Roboto'",
  fontStyle: "normal",
  fontWeight: 300,
  fontSize: "14px",
  lineHeight: "16px",
  color: "#4D4D4D",
  textDecoration: "none",
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "& .MuiFormControlLabel-label": {
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "14px",
    lineHeight: "16px",
    color: "#0B0B0B",
  },
  "& .MuiCheckbox-root": {
    // Styles for the checkbox
    marginRight: "2px",
    color: "rgba(0, 0, 0, 0.8)",
  },
}));

export {
  AdminLoginMain,
  LoginBox,
  HeaderLogo,
  SignIntext,
  FormMain,
  ForgotPasswordMain,
  ForgotPasswordLink,
  StyledFormControlLabel,
};
